import React from "react";
import { toast } from "react-toastify";

function uploadInitiatedNotification(message) {
  // toast.dismiss()

  let notificationMessage = message ? message : "Upload in Progress";

  return (
    toast(notificationMessage, {
      position: "top-right",
      autoClose: false,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
      type: "success",
      toastId: "upload-progress",
    })
  )
}

export default uploadInitiatedNotification;
